import { AlertTriangle, CheckCircle2, Wrench } from "lucide-react";
import { useBackendStatus } from "../hooks/useBackendStatus";
import { useManutencao } from "../hooks/useManutencao";

/**
 * Faixa fixa no topo. Duas situações distintas:
 *
 * 1) AMARELO — manutenção planejada (useManutencao). Só liga quando NÓS
 *    trocamos o flag manutencao.json pra ativo:true antes de uma atualização.
 *    Tem PRIORIDADE: enquanto atualizamos o backend ele naturalmente fica
 *    indisponível, e não queremos assustar com o vermelho de "offline".
 *
 * 2) VERMELHO — servidor offline de verdade (useBackendStatus), queda real
 *    não planejada. Some quando reconecta (confirmação verde por alguns seg).
 */
export function BackendStatusBanner() {
  const { status } = useBackendStatus();
  const manutencao = useManutencao();

  // 1) Manutenção planejada tem prioridade sobre tudo.
  if (manutencao?.ativo) {
    return (
      <div className="fixed top-0 inset-x-0 z-[60] bg-amber-500 text-white text-sm py-2 px-4 flex items-center justify-center gap-2 shadow">
        <Wrench size={16} />
        <span className="font-medium">{manutencao.mensagem}</span>
      </div>
    );
  }

  if (status === "online" || status === "verificando") return null;

  if (status === "reconectado") {
    return (
      <div className="fixed top-0 inset-x-0 z-[60] bg-emerald-600 text-white text-sm py-2 px-4 flex items-center justify-center gap-2 shadow">
        <CheckCircle2 size={16} />
        <span>Conexão restaurada</span>
      </div>
    );
  }

  return (
    <div className="fixed top-0 inset-x-0 z-[60] bg-red-600 text-white text-sm py-2 px-4 flex items-center justify-center gap-2 shadow animate-pulse">
      <AlertTriangle size={16} />
      <span className="font-medium">
        Servidor offline — suas alterações podem não ser salvas. Não feche a aba; estamos tentando reconectar…
      </span>
    </div>
  );
}
